import React from "react"

// Views
import AppPanel from "@views/AppPanel"

// Components
import Headline from "@components/Headline"
import Metatags from "@components/Metatags"

// Material-UI
import Container from "@material-ui/core/Container"

// Markups
import AboutMD from "@views/about.md"

function Code() {
    return (
        <AppPanel>
            <Metatags subtitle="SKIP/ABOUT" path="about" />
            <Headline>SKIP/about</Headline>
            <Container maxWidth="sm">
                <AboutMD />
            </Container>
        </AppPanel>
    )
}

export default Code
